import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageDemographicsSectionSECTION = styled.section`
  background: linear-gradient(180deg, rgba(242, 246, 255, 0) 69.65%, rgba(242, 246, 255, 0.75) 100%), #FFFFFF;
  padding: var(--spacing--L) 0;
`;
